module.exports = function() {
  return new Worker(__webpack_public_path__ + "a0b923f5e9f820ea0909.worker.js");
};